var map = {
	"./30tip.png": 10411,
	"./CRY.png": 61764,
	"./TAP-small.png": 24460,
	"./TAP.png": 63297,
	"./TAPCOINS-small.png": 9474,
	"./TAPCOINS.png": 12129,
	"./TAPSTOCK-small.png": 12337,
	"./TAPSTOCK.png": 68715,
	"./TON.png": 5418,
	"./USDT-small.png": 4943,
	"./USDT.png": 56595,
	"./avatar/avatar-1.png": 24774,
	"./avatar/avatar-2.png": 93337,
	"./avatar/avatar-3.png": 2025,
	"./avatar/avatar-4.png": 28018,
	"./avatar/avatar-5.png": 25571,
	"./blind/bind-box.png": 16670,
	"./blind/bind-select.png": 31329,
	"./blind/blind-container-bg.png": 65899,
	"./blind/blind-items-board.png": 29146,
	"./blind/reward-box.png": 39264,
	"./blind/reward-select.png": 6608,
	"./fortune/fortune-card-Bgblack.png": 99231,
	"./fortune/fortune-card-Bgblue.png": 8874,
	"./fortune/fortune-card-Bggreen.png": 6509,
	"./fortune/fortune-card-Bgorange.png": 61242,
	"./fortune/fortune-card-Bgpink.png": 62714,
	"./fortune/fortune-card-Bgred.png": 72867,
	"./fortune/fortune-card-Bgyellow.png": 78053,
	"./fortune/fortune-card-light.png": 53154,
	"./fortune/fortune-card.png": 35108,
	"./fortune/forturn-star.png": 97267,
	"./fortune/forturn-tag.png": 87539,
	"./fortune/orturn-synthesis-empty.png": 85965,
	"./game-small.png": 76050,
	"./gift-selector-997.png": 94592,
	"./gift-selector-arrow-997.png": 17144,
	"./gift-selector-arrow.png": 53981,
	"./gift-selector.png": 21226,
	"./gift/gift-exclusise-img.png": 89505,
	"./gift/gift-high-img.png": 11073,
	"./hot.png": 3785,
	"./icon-diamond.png": 93365,
	"./icon-gold-1.png": 22444,
	"./icon-group.png": 76515,
	"./icon-menu.png": 70354,
	"./icon-ok.png": 37674,
	"./icon-people.png": 74432,
	"./icon-profit.png": 67918,
	"./icon-ranking.png": 98853,
	"./icon-wallet.png": 16864,
	"./index-bg-gold.png": 33292,
	"./index-icon-boosts.png": 38663,
	"./index-icon-crypto.png": 91607,
	"./index-icon-frens.png": 67993,
	"./index-icon-progress.png": 59021,
	"./index-icon-slots.png": 4282,
	"./index-icon-spin.png": 50241,
	"./lock/avatar-lock-l.png": 76149,
	"./lock/avatar-lock-s.png": 5386,
	"./lock/double_p.png": 45844,
	"./lock/gift-1.png": 43010,
	"./lock/gift-2.png": 69894,
	"./lock/gift-3.png": 37356,
	"./machine/machine-arrow.png": 17336,
	"./machine/machine-bg.png": 5455,
	"./machine/machine-btn1-bg-1.png": 29058,
	"./machine/machine-btn1-bg.png": 87662,
	"./machine/machine-btn2-bg-1.png": 73990,
	"./machine/machine-btn2-bg.png": 60726,
	"./machine/machine-main-bg.png": 92956,
	"./machine/machine-title.png": 39551,
	"./menu-active-bg.png": 36962,
	"./menu-airdrop-active.png": 84387,
	"./menu-airdrop.png": 19842,
	"./menu-app-active.png": 2627,
	"./menu-app.png": 93024,
	"./menu-bg.png": 48030,
	"./menu-earn-active.png": 35656,
	"./menu-earn.png": 78194,
	"./menu-game-active.png": 57508,
	"./menu-game.png": 31929,
	"./menu-gift-active.png": 10321,
	"./menu-gift.png": 47003,
	"./menu-home-active.png": 11681,
	"./menu-home.png": 30399,
	"./menu-nft-active.png": 4654,
	"./menu-nft.png": 86814,
	"./menu-study-active.png": 63565,
	"./menu-study.png": 53568,
	"./menu-tasks-active.png": 27283,
	"./menu-tasks.png": 23570,
	"./mpay-logo.png": 34077,
	"./mpayBanner__title.png": 70369,
	"./nav-icon-achievements.png": 96289,
	"./nav-icon-bounty.png": 18689,
	"./nav-icon-code.png": 4169,
	"./nav-icon-login.png": 82097,
	"./new.png": 76794,
	"./nftInfo/nftInfo-items-bg.png": 8757,
	"./niceLucky/btn-1.png": 70699,
	"./niceLucky/btn-2.png": 72564,
	"./niceLucky/icon-buy.png": 77947,
	"./niceLucky/icon-invite.png": 15850,
	"./niceLucky/icon-shard.png": 82170,
	"./niceLucky/icon-ship.png": 54684,
	"./niceLucky/icon-task.png": 53731,
	"./niceLucky/light.png": 22540,
	"./niceLucky/niceLucky-bottom.png": 52706,
	"./niceLucky/niceLucky-item-active-bg.png": 26666,
	"./niceLucky/niceLucky-item-bg.png": 53468,
	"./niceLucky/niceLucky.png": 13243,
	"./niceLucky/niceLucky_title.png": 2036,
	"./niceLucky/ship-num.png": 42450,
	"./perHour.png": 88043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52167;